import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router";
import * as Yup from "yup";
// import { CountryDropdown } from "react-country-region-selector";
import Loader from "react-loader-spinner";
import { Form, Formik } from "formik";
import { pick, cloneDeep } from "lodash";

import {
  StyledContainer,
  StyledFormArea,
  StyledFormButton,
  StyledTitle,
  ButtonGroup,
  SubTitle,
  ExtraText,
  TextLink,
  colors,
} from "../../Syles/styles";
import LogoIcon from "../../Logo/Logo";
import {
  TextInput,
  CodeTextInput,
  PhoneNumberTextInput,
} from "../../pages/Formik/FormLib";

import { createUserAction } from "../../../store/user/user.action";
import { Util } from "../../../helpers/util";
import "react-phone-input-2/lib/style.css";
import "./SignUp.css";
import { $api } from "../../../helpers/$api";

const CountryDropdown = ({ countries, ...props }) => {
  return (
    <select {...props}>
      <option value="" children="Select Country" />
      {countries
        .sort((a, b) => (a.name < b.name ? -1 : 1))
        .map((country) => {
          return (
            <option
              value={country.name}
              children={country.name}
              key={country.id}
            />
          );
        })}
    </select>
  );
};

const PhoneCode = ({ countries, ...props }) => {
  return (
    <CodeTextInput {...props}>
      <option value="" children="" />

      {countries
        .sort(({ phonecode: a }, { phonecode: b }) => a - b)
        .map((country) => {
          return (
            <option
              value={country.phonecode}
              children={`+${country.phonecode}`}
              key={country.id}
            />
          );
        })}
    </CodeTextInput>
  );
};

const SignUp = ({ user, createUser, ...props }) => {
  const [showLoader, setShowLoader] = useState(false);
  const [countries, setCountries] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState({});

  useEffect(() => {
    (async () => {
      try {
        const countries = await $api.user.getCountries();

        setCountries(countries);
      } catch (error) {
        console.debug(error);
      }
    })();
  }, [setCountries]);

  const isLoggedIn = !!user;
  if (isLoggedIn) {
    const { continue_to } = Util.parseQueryString(props.location.search);
    if (continue_to) {
      window.location = continue_to;
      return null;
    }
    return <Redirect to="/dashboard" />;
  }

  const handleSubmit = async (values, { setFieldError }) => {
    try {
      setShowLoader(true);
      await createUser(values);
    } catch (error) {
      if (error.isHttpException) {
        error.data.forEach(([key, message]) => {
          setFieldError(key, message);
        });
      }
    } finally {
      setShowLoader(false);
    }
  };

  const handleCountrySelect = (event, setFieldValue) => {
    const { value } = event.target;
    const selectedCountry = countries.find(
      (country) =>
        country.name === value || country.phonecode.toString() === value
    );

    setSelectedCountry(selectedCountry);
    setFieldValue("phone_code", selectedCountry.phonecode);
  };

  const phoneRegExp =
    /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

  return (
    <StyledContainer>
      <div className="Sign-in">
        <LogoIcon />

        <StyledFormArea>
          <div
            style={{
              paddingBottom: "10px",
              paddingTop: "5px",
            }}
          >
            <StyledTitle size={20}>Create a Secure Account</StyledTitle>
            <SubTitle>
              Let’s meet you. A step towards achieving your goals!
            </SubTitle>
          </div>
          <Formik
            initialValues={{
              firstname: "",
              lastname: "",
              email: "",
              phone: "",
              referal: "",
              country: selectedCountry.name,
              password: "",
              password_confirmation: "",
              username: "",
              phone_code: selectedCountry.phonecode,
            }}
            onSubmit={handleSubmit}
            validationSchema={Yup.object({
              firstname: Yup.string().required("Firstname is Required"),
              lastname: Yup.string().required("Lastname is Required"),
              email: Yup.string()
                .email("Invalid email address")
                .required("email is Required"),
              phone: Yup.string()
                .matches(phoneRegExp, "Phone number is not valid")
                .required("Phone Number is Required"),
              // referral: Yup.string().required("City is Required"),
              country: Yup.string().required("Country is Required"),
              password: Yup.string()
                .min(8, "password is too short")
                .max(30, "password is too long")
                .required("Password is Required"),
              password_confirmation: Yup.string()
                .required("confirm_password is Required")
                .oneOf([Yup.ref("password"), "Passwords must match"]),
              username: Yup.string().required("Username is Required"),
              phone_code: Yup.string().required("Phone Code is Required"),
            })}
          >
            {({
              isSubmitting,
              values,
              handleBlur,
              handleChange,
              setFieldValue,
            }) => (
              <Form>
                <CountryDropdown
                  id="country"
                  className="Sign-up-country"
                  name="country"
                  value={selectedCountry.name}
                  onChange={(e) => {
                    handleCountrySelect(e, setFieldValue);
                    handleChange(e);
                  }}
                  onBlur={handleBlur}
                  countries={countries}
                />
                <TextInput
                  type="text"
                  name="firstname"
                  placeholder="First Name"
                />
                <TextInput
                  type="text"
                  name="lastname"
                  placeholder="Last Name"
                />{" "}
                <TextInput
                  type="email"
                  name="email"
                  placeholder="email@mail.com"
                />{" "}
                <TextInput
                  name="username"
                  type="text"
                  placeholder=" Username"
                />
                {/* <TextInput type="tel" name="phone" placeholder="Phone Number" />{" "} */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <PhoneCode
                    type="tel"
                    name="phone_code"
                    countries={countries}
                    onChange={handleCountrySelect}
                    disabled={true}
                    value={selectedCountry.phonecode}
                  />

                  <PhoneNumberTextInput
                    type="tel"
                    name="phone"
                    placeholder="Phone Number"
                  />
                </div>
                <TextInput
                  type="text"
                  name="referal"
                  placeholder="Referral Code"
                />{" "}
                <TextInput
                  name="password"
                  type="password"
                  placeholder="Password"
                />
                <TextInput
                  name="password_confirmation"
                  type="password"
                  placeholder="Confirm Password"
                />
                <ButtonGroup>
                  {!showLoader && (
                    <StyledFormButton type="submit">Sign Up</StyledFormButton>
                  )}

                  {showLoader && (
                    <Loader
                      type="ThreeDots"
                      color={colors.primary}
                      height={49}
                      width={100}
                    />
                  )}
                </ButtonGroup>
              </Form>
            )}
          </Formik>

          <ExtraText>
            Already an OVestor? <TextLink to="/login">Login</TextLink>
          </ExtraText>
        </StyledFormArea>
      </div>
    </StyledContainer>
  );
};

const mapStateToProps = (state) => pick(cloneDeep(state), ["user"]);
const mapDispatchToProps = { createUser: createUserAction };

export default connect(mapStateToProps, mapDispatchToProps)(SignUp);
